import { render } from "./FilterBlock.vue?vue&type=template&id=010fafa1&scoped=true"
import script from "./FilterBlock.vue?vue&type=script&lang=js"
export * from "./FilterBlock.vue?vue&type=script&lang=js"

import "./FilterBlock.vue?vue&type=style&index=0&id=010fafa1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-010fafa1"]])

export default __exports__